module.exports = __webpack_public_path__ + "img/RK-Extension-Interface.webp";